export const initialState = {
  country: {}
  
};

const filtersReducer = (state = { country: {}, terminal: 0, terminalList: [], iata: '', agency: {}, agencyList: [], agencyCountry: {}, clientCountry: {}, client: {}, clientList: [] }, action) => {
  switch (action.type) {
    case 'FILTER_BY_COUNTRY':
      return { ...state, country: action.data };
    case 'FILTER_BY_TERMINAL':
      return { ...state, terminal: action.data };
    case 'FILTER_BY_IATA':
      return { ...state, iata: action.data || '' };
    case 'FILTER_BY_AGENCY':
      return { ...state, agency: action.data };
    case 'FILTER_BY_AGENCY_COUNTRY':
      return { ...state, agencyCountry: action.data };
    case 'FILTER_BY_CLIENT_COUNTRY':
      return { ...state, clientCountry: action.data };
    case 'FILTER_BY_CLIENT':
      return { ...state, client: action.data };
    case 'TERMINAL_ACCESIBLE_LIST':
      try {
        // console.log('>>> Reducer terminalList:', action.data);
        return { ...state, terminalList: Array.isArray(action.data) ? action.data : JSON.parse(action.data || '[]') };
      } catch (error) {
        console.error('Reducer error:', error);
        return state;
      }
    case 'AGENCY_ACCESSIBLE_LIST':
      try {
        return { ...state, agencyList: Array.isArray(action.data) ? action.data : JSON.parse(action.data || '[]') };
      } catch (error) {
        console.error('Reducer error:', error);
        return state;
      }
    case 'CLIENT_ACCESSIBLE_LIST':
      try {
        return { ...state, clientList: Array.isArray(action.data) ? action.data : JSON.parse(action.data || '[]') };
      } catch (error) {
        console.error('Reducer error:', error);
        return state;
      }
    default:
      return state;
  }
};

export default filtersReducer;
